// Module
var code = "<template class=\"comp-loader theme-${theme}\"> <svg class=\"comp-loader--svg\" width=\"20px\" height=\"20px\" viewBox=\"0 0 66 66\" xmlns=\"http://www.w3.org/2000/svg\"> <circle class=\"comp-loader--svg-circle\" fill=\"none\" stroke-width=\"6\" stroke-linecap=\"round\" cx=\"33\" cy=\"33\" r=\"30\"></circle> </svg> </template>";
// Exports
module.exports = code;